<template>
  <div
    class="video_pc"
    :style="{ transform: containerTransform }"
    ref="videoContainer"
  >
    <div class="swiper-wrapper">
      <div
        v-for="(item, index) in flixList[0]"
        :key="index"
        class="swiper-slide"
      >
        <div
          class="spinner-border-loader text-primary"
          role="status"
          v-if="loadingItem"
        >
          <span class="loader-triangle"></span>
        </div>

        <Video
          v-else-if="index === activeIndex"
          :video_url="handleReturnUrl(item)"
          :video_source="item?.video_source"
          :video_poster="item?.thumbnail ?? item_image"
          :access="handleCheckAccess(access, item)"
          :is_small_device="smallDevice"
          @handleVideoHasEnded="handleVideoHasEnded"
          @handleCheckMoves="handleCheckMoves"
          @handleLoadNext="handleLoadNextVideo"
        />
        <img
          v-else
          :src="item?.thumbnail ?? item_image"
          class="img-fluid"
          alt="thumbnail"
        />

        <div
          class="pay-btn-container"
          v-if="!handleCheckAccess(access, item) && !loadingItem"
          role="button"
          @click="handlePaymentModal"
        >
          <span class="lock-icon">
            <i
              class="fa fa-lock"
              aria-hidden="true"
            ></i>
          </span>
          Unlock This Episode
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Video from './components/video.vue';
import Swiper from 'swiper';
import 'swiper/css/swiper.css';
import axios from 'axios';

export default {
  name: 'VideoContainer',
  components: { Video },
  props: {
    flixItems: {
      type: Object | null,
      required: true,
    },
    access: {
      type: Boolean,
      required: true,
    },
    smallDevice: {
      type: Boolean,
      required: false,
      default: false,
    },
    item_image: {
      type: String,
      required: false,
    },
    loadingItem: {
      type: Boolean,
      required: false,
      default: false,
    },
  },

  data() {
    return {
      showBackBotton: true,
      containerTransform: 'none',
      swipeRef: null,
      flixList: [],
      secondItemLoaded: false,
      activeIndex: 0,
      is_last_item: false,
    };
  },
  created() {},

  mounted() {
    const initSwiperTimeout = setTimeout(() => {
      this.initSwiper();
      clearTimeout(initSwiperTimeout);
    }, 1000);

    this.handleGetWindowHeight();
    window.addEventListener('resize', this.handleGetWindowHeight);
    this.flixList.push(this.flixItems);
  },

  methods: {
    handleCheckAccess(access, item) {
      if (item?.highlight === 1) {
        return true;
      } else {
        return access;
      }
    },

    handleClose: function () {
      window.location.replace(window.location.origin + '/');
    },
    handlePaymentModal() {
      this.$emit('openPlansModal');
    },

    handleVideoHasEnded() {
      this.$emit('handleVideoHasEnded');
      this.activeIndex + 1;
      this.swipeRef.slideNext();
    },
    handleLoadNextVideo() {
      this.$emit('handleNext', true);
    },

    handleCheckMoves(showController) {
      this.showBackBotton = showController;
      this.$emit('handleCheckMoves', showController);
    },

    handleGetWindowHeight() {
      const vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty('--vh', `${vh}px`);
    },
    initSwiper() {
      this.swipeRef = new Swiper(this.$refs.videoContainer, {
        direction: 'vertical',
        slidesPerView: 1,
        mousewheel: true,
        spaceBetween: 30,
        initialSlide: 0,
        init: false,
        centeredSlides: true,
        loop: false,
        observer: true,
        on: {
          slideChange: () => {
            this.activeIndex = this.swipeRef.realIndex;
            this.$emit('handleSwipeChange', this.swipeRef.realIndex);
            const activeItem = this.flixList[0][this.swipeRef.realIndex];
            this.handleChangedActiveItem(activeItem);
            if (this.swipeRef.realIndex === this.swipeRef.slides.length - 2) {
              if (!this.is_last_item) {
                this.handleLoadSecondItem();
              }
            }
          },
        },
      });

      this.swipeRef.init();
    },
    handleLoadSecondItem() {
      const lastItemIndex = Object.keys(this.flixList[0]).length - 1;
      const lastItem =
        this.flixList[0][Object.keys(this.flixList[0])[lastItemIndex]];

      if (lastItem) {
        axios
          .get(
            `/flix/item?playlist_id=${lastItem?.flix_playlist_id}&item_id=${lastItem?.id}&next=true`,
          )
          .then((response) => {
            const newItem = response.data.item;
            this.is_last_item = response.data.is_last_item;
            if (!this.is_last_item) {
              this.$set(this.flixList[0], this.flixList[0].length, newItem);
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }
      this.swipeRef.updateSlides();
      this.swipeRef.updateSlidesClasses();
    },

    handleChangedActiveItem(item) {
      const access = this.handleCheckAccess(this.access, item);
      if (!access) {
        this.$emit('openPlansModal');
        this.swipeRef.allowSlideNext = false;
      } else {
        this.swipeRef.allowSlideNext = true;
      }
    },

    handleTriggerNextSlide(){
        this.swipeRef.slideNext();
    },
      handleReturnUrl(item){
        if(item?.video_url instanceof Object){
          return item?.video_url?.link
        }
        else{
          return item?.video_url
        }
      }
    
  },
};
</script>

<style scoped>
.video_pc {
  position: relative;
  z-index: 2;
  width: 560px;
  background-color: #000000c9;
  overflow: hidden;
  height: 100%;
}

@media (min-width: 1024px) {
  .video_pc {
    width: 460px;
  }
}

@media (max-width: 768px) {
  .video_pc {
    width: 100%;
    height: 100%;
  }
}

@media screen and (max-width: 768px) {
  .small-top-header {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    width: 100%;
    height: 52px;
    z-index: 3;
    display: block !important;
    padding: 20px;
  }

  .small-top-header-content {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    color: white;
    font-weight: 900;
  }

  .title-text-white {
    color: white;
    text-wrap: nowrap;
    word-break: keep-all;
  }

  .video-player-container {
    height: 100%;
    max-height: 100%;
  }
}
.small-top-header {
  display: none;
}
.video-player-container {
  position: relative;
  z-index: 2;
  width: 100%;
  overflow: hidden;
  display: grid;
  place-items: center;
  height: calc(var(--vh, 1vh) * 100);
  min-height: -webkit-fill-available;
}

.loader-triangle {
  position: relative;
  width: 48px;
  height: 48px;
}
.loader-triangle:before,
.loader-triangle:after {
  content: '';
  display: block;
  border: 32px solid transparent;
  border-top-color: #fff;
  position: absolute;
  left: 0;
  top: 0;
  animation: weld-rotate 2s infinite ease-in;
}
.loader-triangle:before {
  border-color: transparent transparent transparent #198754;
  animation-delay: 0.5s;
}
@keyframes weld-rotate {
  0%,
  25% {
    transform: rotate(0deg);
  }
  50%,
  75% {
    transform: rotate(180deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.spinner-border-loader {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.pay-btn-container {
  position: absolute;
  top: 40%;
  left: 30%;
  width: 250px;
  background: #0f4c47;
  border-radius: 10px;
  z-index: 3;
  justify-content: center;
  padding: 15px;
  align-items: center;
  display: flex;
  color: white;
  font-size: 20px;

  .lock-icon {
    margin-right: 10px;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 30px;
    height: 30px;

    i {
      font-size: 13px;
    }
  }
}
.pay-btn-container .lock-icon::after {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 30px;
  height: 30px;
  background: #252727bd;
  border-radius: 50%;
  z-index: -1;
}
.pay-btn-container:hover {
  cursor: pointer;
  background: #0f4c47;
}

@media screen and (max-width: 768px) {
  .pay-btn-container {
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
}

.video_pc {
  transition: transform 0.3s ease;
}

.swipe-up {
  transform: translateY(-150px);
}

.swipe-down {
  transform: translateY(150px);
}
.img-fluid {
  height: 100%;
  object-fit: cover;
  object-position: center;
}
</style>
